import {
  SET_MODAL_CONFIG,
  CLEAR_MODAL_CONFIG,
  OPEN_SERVICES_MODAL,
  CLOSE_SERVICES_MODAL,
  CHANGE_MODAL_CONFIG,
} from './types';

export const openServicesModal = () => ({
  type: OPEN_SERVICES_MODAL,
});

export const setServiceModalConfig = ({ patchInfo, modalType, theme }) => {
  return {
    type: SET_MODAL_CONFIG,
    patchInfo,
    modalType,
    theme,
  };
};

export const clearServiceModalConfig = () => {
  return {
    type: CLEAR_MODAL_CONFIG,
  };
};

export const changeServiceModalTheme = ({ theme }) => {
  return {
    type: CHANGE_MODAL_CONFIG,
    theme,
  };
};

export const closeServicesModal = () => ({ type: CLOSE_SERVICES_MODAL });



// WEBPACK FOOTER //
// ./src/redux/actions/addToDayModalactions.js